export const ADD_IMAGE_SUCCESS = 'session/ADD_IMAGE_SUCCESS'
export const ADD_IMAGE_FAILURE = 'session/ADD_IMAGE_FAILURE'
export const ADD_IMAGE_STARTED = 'session/ADD_IMAGE_STARTED'
